// Supported file formats for book uploads
export const BOOK_FILE_FORMATS = {
  extensions: ['.fb2', '.epub', '.zip'],
  mimeTypes: ['application/x-fictionbook+xml', 'application/epub+zip', 'application/zip'],
  acceptString: '.fb2,.epub,.zip',
  displayString: 'FB2, EPUB, ZIP'
} as const

// Supported image formats for cover uploads
export const IMAGE_FILE_FORMATS = {
  extensions: ['.jpg', '.jpeg', '.png', '.webp'],
  mimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
  acceptString: 'image/*',
  displayString: 'JPG, PNG, or WebP'
} as const

/**
 * Validates if a file has a supported book format
 */
export function isValidBookFile(file: File): boolean {
  const fileName = file.name.toLowerCase()
  return BOOK_FILE_FORMATS.extensions.some(ext => fileName.endsWith(ext))
}

/**
 * Validates if a file is an image
 */
export function isValidImageFile(file: File): boolean {
  return file.type.startsWith('image/')
}

